module.exports = __webpack_public_path__ + "img/Logo-oficial.db17d426.png";